import { useReadContract } from "wagmi";
import useDappChain from "./useDappChain";
import useDappConfig from "./useDappConfig";
import { formatUnits, parseUnits } from "viem";
import { useSelector } from "react-redux";
import { ETH } from "@config/contractsConfig";

const useUnstakeEstimate = (amount: string) => {
  const { chain, isEthereumChain } = useDappChain();
  const { config, isRestakeSupported } = useDappConfig();
  const { selectedERC20 } = useSelector((state: any) => state.user);

  const assetToWithdrawInto =
    selectedERC20 === ETH ? config.nativeToken : config.tokens[selectedERC20];

  const formattedAmount = !Number.isNaN(amount) ? parseUnits(amount, 18) : "0";

  const { data } = useReadContract({
    ...config.interactionPools.lrtWithdrawalManager,
    functionName: "getExpectedAssetAmount",
    args: [assetToWithdrawInto?.address, formattedAmount],
    query: {
      enabled:
        chain &&
        isRestakeSupported &&
        isEthereumChain &&
        formattedAmount !== "0" &&
        !!assetToWithdrawInto,
    },
  });

  return data
    ? {
        returns: formatUnits(data as bigint, 18),
      }
    : { returns: "0" };
};

export default useUnstakeEstimate;
